import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/write-now/resources/${resource.id}/edit`} />,
    <MenuItem primaryText='Category' key='members' value={`/write-now/resource_categories/${resource.resource_category_id}/edit`} />
  ]
}

export default buildMenuItems
